exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".certification-icon-tooltip {\n  font-size: 14px;\n}\n\n.certification-icon-img {\n  width: 16px;\n  height: 16px;\n}\n", ""]);

// exports
